import { render } from "./navheader.vue?vue&type=template&id=3da9bc1c"
import script from "./navheader.vue?vue&type=script&lang=js"
export * from "./navheader.vue?vue&type=script&lang=js"

import "./navheader.vue?vue&type=style&index=0&id=3da9bc1c&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__